import PropTypes from 'prop-types'

import Checkbox from 'components/Checkbox'

import FormSection from 'pages/shared/FormSection'

import Brand from 'helpers/brand'

const propTypes = {
  selectedBrands: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChangeCallback: PropTypes.func.isRequired,
  errors: PropTypes.shape(PropTypes.shape)
}

const defaultProps = {
  errors: {}
}

const BrandFields = ({ selectedBrands, onChangeCallback, errors }) => {
  const allBrands = Brand.allBrandsOfCurrentBusinessUnit()

  const onBrandChange = (brand) => {
    const updatedBrands = _.contains(selectedBrands, brand)
      ? _.without(selectedBrands, brand)
      : _.union(selectedBrands, [brand])

    onChangeCallback({ brands: updatedBrands })
  }

  return (
    <FormSection title="Brands">
      {
        allBrands.map((brand) => (
          <Checkbox
            key={brand}
            label={Brand.productName(brand)}
            checked={selectedBrands.includes(brand)}
            onChange={() => onBrandChange(brand)}
            errorMessage={_.last(allBrands) === brand ? errors.brands : null}
          /> // TODO: DWA-2639 refactor to wrap set of checkboxes in container and have one error field for container
        ))
      }
    </FormSection>
  )
}

BrandFields.propTypes = propTypes
BrandFields.defaultProps = defaultProps

export default BrandFields
